module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pt-sans",
    attrs: {
      "ma-0": "",
      "pa-0": "",
      "fluid": ""
    }
  }, [_c('v-slide-x-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "top-blur circular"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": 70,
      "width": 3,
      "color": "error"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('v-layout', {
    staticClass: "border-bottom",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "offset-md1": "",
      "md10": "",
      "pt-2": "",
      "pb-2": ""
    }
  }, [_c('span', {
    staticClass: "nome pull-left"
  }, [_vm._v("\n        Seja bem-vindo(a), "), _c('strong', {
    staticClass: "capitalize"
  }, [_vm._v(_vm._s(_vm.nomeUsuario))]), _vm._v(" - "), _c('strong', [_vm._v(_vm._s(_vm.tradingName))])]), _vm._v(" "), _c('span', {
    staticClass: "pull-right pl-2 link",
    on: {
      "click": _vm.sair
    }
  }, [_vm._v("\n        sair\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right pl-2 link",
    on: {
      "click": _vm.minhaConta
    }
  }, [_vm._v("\n        minha conta\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right pl-2 link",
    on: {
      "click": _vm.ShowManualEvent
    }
  }, [_vm._v("\n        ajuda\n      ")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "offset-md1": "",
      "md1": ""
    }
  }, [_c('img', {
    staticClass: "mt-2 mb-2",
    staticStyle: {
      "width": "60px",
      "height": "60px"
    },
    attrs: {
      "src": require("../../assets/logo.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md9": ""
    }
  }, [_c('v-tabs', {
    staticClass: "menu-tabs",
    attrs: {
      "grow": "",
      "value": _vm.rota,
      "slider-color": "red",
      "hide-slider": !_vm.sliderMenu,
      "height": "82"
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('v-tab', {
      key: '/Painel/' + tab.menu,
      attrs: {
        "to": '/Painel/' + tab.url,
        "ripple": false
      }
    }, [_c('v-icon', {
      staticClass: "mr-2"
    }, [_vm._v(_vm._s(tab.icon))]), _vm._v(_vm._s(tab.nome) + "\n        ")], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-slide-x-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1), _vm._v(" "), _c('order-details'), _vm._v(" "), _c('Feedback', {
    staticClass: "feedback-btn",
    attrs: {
      "token": _vm.token,
      "generalFeedback": _vm.generalFeedback
    }
  }), _vm._v(" "), _c('manual', {
    attrs: {
      "toShow": _vm.showModal
    },
    on: {
      "update:toShow": function($event) {
        _vm.showModal = $event
      },
      "update:to-show": function($event) {
        _vm.showModal = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c6d89e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/index.vue
// module id = 760
// module chunks = 6